import { render } from "./ModalActivateChannel.vue?vue&type=template&id=329c1a51&scoped=true&ts=true"
import script from "./ModalActivateChannel.vue?vue&type=script&lang=ts"
export * from "./ModalActivateChannel.vue?vue&type=script&lang=ts"

import "./ModalActivateChannel.vue?vue&type=style&index=0&id=329c1a51&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-329c1a51"]])

export default __exports__